import React from 'react'
import Button from '../../../components/buttons/buttons.component'
import { history } from './../../../helpers/history'
import { routes } from './../../../constants/routes.constants'
import { RoleConstants } from './../../../constants/role.constants'

const RedeemButton = ({ user, client, productId, paymentCondition, role }) => {
	var notAuthenticated = user === null
	if (RoleConstants.Client !== role && !notAuthenticated) return null

	const balancePoints =
		client.balancePoints === undefined ? 0 : client.balancePoints
	const points =
		paymentCondition.points === undefined ? 0 : paymentCondition.points

	let balance = notAuthenticated ? 0 : balancePoints - points

	const showRedeemButton = notAuthenticated || balance >= 0
	const text = showRedeemButton ? 'Comprar' : 'Comprar pontos'
	const productUrl = `${routes.CLIENTE}/loja/resgatar/${productId}`
	const productDetailUrl = `${routes.CLIENTE}/loja/produto/${productId}`

	const onClick = () => {
		if (notAuthenticated) {
			history.push('/entrar', { redirectUrl: productDetailUrl })
		} else {
			const route = showRedeemButton
				? productUrl
				: '/cliente/compra-de-pontos'

			const data =
				route === productUrl
					? { selectedPaymentCondition: paymentCondition }
					: {}

			history.push(route, data)
		}
	}

	return (
		
		<Button primary type={'button'} onClick={onClick}>
			{text}
		</Button>
	)
}

export default RedeemButton
